<script setup lang="ts">
    // requestToken();
    const route = useRoute();
</script>
<template>
    <Header />
    <div class="h-[48px]"></div>
    <div class="min-h-[calc(100vh-112px)]">
        <router-view
            :key="route.fullPath"
            :class="route.meta.notUseTabBar ? 'min-h-[calc(100vh-48px)]' : 'min-h-[calc(100vh-112px)]'"
        />
    </div>
    <influencer-add-button />
    <Footer />
    <tab-bar/>
</template>

